import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination , FreeMode } from 'swiper/modules';

function whyfinbourne() {
    const whyfin = document.querySelector('[data-target="whyfin"]');
    
    if (!whyfin) { return; }

    const whyfin_box = document.querySelectorAll('[data-target="whyfin_box"]');

    whyfin_box.forEach(function(element) {
        const content_el_h3 = element.querySelector('h3')
        const content_el_p = element.querySelector('p')
        const content_el_img = element.querySelector('img')
        const content_el_img_wrap = element.querySelector('.absolute')
        
        
        const tlwhyfinbox = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: "top 90%",
                 end:"+=60%",
				 scrub:true
            }
        });

        tlwhyfinbox
            .to(element, { scale: 1, duration: 1, ease: "power3.inOut" }) 
            .to([content_el_h3, content_el_p], { autoAlpha: 1, duration: 0.5 }, "-=0.5") 
            .from(content_el_img_wrap, {autoAlpha:0, duration:0.5}, "-=0.2")
            .to([content_el_img], { autoAlpha: 1, duration: 0.5 }, "-=0.5") 
    });

}


export { whyfinbourne }; 